export enum E_ObservationValueType {
  Number = 'Number',
  String = 'String',
  Boolean = 'Boolean',
  Date = 'Date',
}